
export const hostUrl = 'http://www.notioni.com:8091'
// export const hostUrl = 'http://47.74.253.193:8091'


export const options = {
	param:'jsonpCallback'
};

export const commonParams = {
	
};

export const ERR_OK = 0 ;




// WEBPACK FOOTER //
// ./src/api/config.js